import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "InputWrapper",
  props: {
    label: { type: String, default: null },
    labelClass: { type: [Array, Object, String], default: null },
    id: { type: String, default: null },
    errorMessage: { type: [String, Boolean], default: null },
    required: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    showLabel: { type: Boolean }
  },
  computed: {
    hasError() {
      return !!this.errorMessage;
    },
    wrapperClass() {
      const classes = [];
      if (this.hasError) {
        classes.push("input-wrapper--error");
      }
      if (this.disabled) {
        classes.push("input-wrapper--disabled");
      }
      if (this.readonly) {
        classes.push("input-wrapper--readonly");
      }
      return classes;
    }
  }
});
export {
  _sfc_main as default
};
